/* eslint-disable react/jsx-props-no-spreading */
import withLayout from '../helpers/withLayout';
import AuthorizedRoute from './AuthorizedRoute';

export default withLayout(AuthorizedRoute);
